import { useState } from 'react';
import HeroSection from './HeroSection';
import Layout from './Layout';
import GetStartedCard from './GetStartedCard';
import { Button } from './ui/button';
import SupportCard from './SupportCard';
import { CalendarCheck, Clock8, Sparkles, UserRound } from 'lucide-react';

export default function ApplicantsAssessmentPage() {
  return (
    <div>
      <Layout>
        <div className="space-y-32 pb-20">
          <div>
            <HeroSection
              title="From Scenario to Simulation in Seconds"
              description="Access our extensive library of professional quality simulations, with Simulations Copilot to help you find exactly what you need."
              image="/images/simulations-copilot/hero.png"
              blueTitle="Simulations Copilot - AI-Powered Feature"
              buttons={[
                {
                  text: 'Get Started for Free',
                  link: 'https://app.simulationslabs.com/register/tenant',
                  variant: 'default',
                },
                {
                  text: 'Watch Demo',
                  link: '#demo',
                  variant: 'outline',
                },
              ]}
            />
          </div>
          <div className="items-center justify-between gap-20 text-center md:grid">
            <div className="mx-auto space-y-4">
              <h1 className="text-[42px] font-medium">
                Smart Recommendations from Existing Challenges
              </h1>
              <p className="text-gray-500">
                Our Simulations Copilot uses advanced AI to instantly find the best matches from our
                extensive library of simulations, saving you time and effort.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-4 text-center md:grid-cols-2 lg:grid-cols-4">
              <SupportCard
                icon={<Clock8 />}
                isCenter={true}
                title="Save Creation Time"
                description="Before investing hours building a new challenge, instantly discover relevant existing simulations that already match your needs."
              />
              <SupportCard
                icon={<Sparkles />}
                isCenter={true}
                title="Instant Matches"
                description="Describe your simulation scenario and get top-ranked matches instantly with AI."
              />
              <SupportCard
                icon={<UserRound />}
                isCenter={true}
                title="Expert-Designed"
                description="Access professional challenges covering real-world vulnerabilities, tools, and roles."
              />
              <SupportCard
                icon={<CalendarCheck />}
                isCenter={true}
                title="Up-to-Date"
                description="Leverage a continuously growing library, keeping your simulations current with the latest cybersecurity trends and scenarios."
              />
            </div>
          </div>
          <div className="items-center justify-between gap-10 md:flex">
            <div id="demo" className="grid space-y-10">
              <div className="text-center">
                <span className="text-lightBlue text-[15px] font-bold uppercase">
                  Interactive Demo
                </span>
                <h1 className="text-[42px] font-medium">How It Works</h1>
              </div>
              <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
                <GetStartedCard
                  number="01"
                  title="Describe Your Scenario"
                  description="Enter the details of your simulation—tools, skills, topics, category, and difficulty level."
                />
                <GetStartedCard
                  number="02"
                  title="AI Recommends Matches"
                  description="Our AI instantly finds top simulations from our library that align with your goals."
                />
                <GetStartedCard
                  number="03"
                  title="Preview and Select"
                  description="Review the recommended simulations and select the ones you want—challenges will be created and ready to use in your events."
                />
              </div>
              <div
                style={{
                  position: 'relative',
                  paddingBottom: 'calc(53.71527777777778% + 41px)',
                  height: '0',
                  width: '100%',
                }}
              >
                <iframe
                  src="https://demo.arcade.software/DGhdkaIeSh8McCtQ55CR?embed&embed_mobile=inline&embed_desktop=inline&show_copy_link=true"
                  title="Create simulations with AI"
                  frameBorder="0"
                  loading="lazy"
                  allowFullScreen
                  allow="clipboard-write"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    colorScheme: 'light',
                  }}
                />
              </div>
              <Button
                onClick={() =>
                  (window.location.href = 'https://app.simulationslabs.com/register/tenant')
                }
                className="mx-auto w-fit"
              >
                Get Started for Free
              </Button>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}
